
import {
  state,
  orderByPropName,
  getSelectModes,
  loadAll,
  switchToView,
  is1stLevelStakeholdersMode,
} from "@/store";
import { debounce } from "lodash";
import { computed, defineComponent } from "vue";

export default defineComponent({
  setup() {
    return {
      state,

      switchToView: function (routeName: string) {
        return switchToView(routeName);
      },

      orderByPropName,
      is1stLevelStakeholdersMode,
      getSelectModes: computed(() => getSelectModes()),

      mode: computed(() => {
        return state.mode;
      }),
    };
  },

  watch: {
    async mode() {
      await loadAll(this.$router.currentRoute, false);
    },
  },
});
